import { HttpTypes } from '@/types';
import { AxiosInstance } from 'axios';

class Billing {
  private readonly client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async list(
    queryParams: HttpTypes.AdminBillingParams
  ): Promise<HttpTypes.AdminBillingListResponse> {
    const response = await this.client.get('/sites/billing', {
      params: queryParams,
    });

    return response.data;
  }
  async get(id: string): Promise<HttpTypes.AdminBillingResponse> {
    const result = await this.client.get(`/sites/billing/${id}`);
    return result.data;
  }
}

export default Billing;
